import type { PassedCertificationExpanded } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import useSWRImmutable from "swr/immutable";

const usePassedCertifications = () => {
	const { isSignedIn } = useAuth();
	const res = useSWRImmutable<PassedCertificationExpanded[]>(
		isSignedIn && `/certifications/passed`,
		{
			errorRetryCount: 0,
		},
	);

	const isCertificationPassed = (certificationSlug: string) => {
		return res.data?.some(
			(passedCertification) =>
				passedCertification.certification.slug === certificationSlug,
		);
	};

	return {
		...res,
		isCertificationPassed,
		isLoadingPassedCertifications: res.isLoading,
		passedCertifications: res.data,
	};
};

export default usePassedCertifications;
